module.exports = __webpack_public_path__ + "static/media/iskall.1e5968b3.mp3";